import { useEffect, useRef, useState } from "react";
const useMeasureOverflow = ()=>{
    const measureRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [isMeasured, setIsMeasured] = useState(false);
    useEffect(()=>{
        const timeoutId = window.setTimeout(()=>{
            if (measureRef.current && !isMeasured) {
                const { scrollHeight, clientHeight } = measureRef.current;
                setIsOverflowing(scrollHeight > clientHeight);
                setIsMeasured(true);
            }
        });
        return ()=>{
            window.clearTimeout(timeoutId);
        };
    }, [
        isMeasured
    ]);
    return {
        measureRef,
        isOverflowing,
        isMeasured
    };
};
export { useMeasureOverflow };
